var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('SvgIcon',{attrs:{"icon-class":"coc-empty","class-name":"empty-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }